import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import SrvButton from "../global/SrvButtonLink";

function CardDescription({ text, rows, placeholder, updateHandler, loading, log, hide, setHide }) {

    const [edit, setEdit] = useState(false);
    const [formText, setFormText] = useState(false);

    useEffect(() => {
        setFormText(text);
    }, [text]);


    useEffect(() => {
        if (hide === true) {
            setEdit(false)
        }
    }, [hide]);

    function EditTextHandler() {
        //setEdit(false);
        if (updateHandler !== undefined) {
            updateHandler(formText);
        }
    }

    return (
        <>
            {edit === false ?
                (
                    <>
                        {formText === null ?
                            <SrvButton typeBtn="add" textBtn={placeholder} onClick={() => { setEdit(true); setHide(false) }} />
                            :
                            <div style={{ cursor: 'pointer' }} onClick={() => { setEdit(true); setHide(false) }}>{formText}</div>
                        }
                    </>
                )
                :
                (
                    <>
                        <textarea className="form-control" rows={rows} placeholder={placeholder}
                            onChange={(e) => { e.target.value === '' ? setFormText(null) : setFormText(e.target.value) }}
                            onBlur={() => EditTextHandler()}
                            defaultValue={formText}
                            disabled={loading}
                        >
                        </textarea>
                        {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                        <div className="text-center mt-15">
                            <button className="mr-5 btn-square btn btn-light text-center" onClick={() => { EditTextHandler(); }} disabled={loading}>
                                <FontAwesomeIcon icon={faSave} className="mr-5 opacity-50" /> Сохранить
                            </button>
                        </div>
                    </>
                )
            }
        </>
    )
}

export default CardDescription;